module.exports = __webpack_public_path__ + "img/h5-banner.be75d8fb.png";